// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { jsonObjectGuard, partialColorGuard, brandingGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    description: z.string().max(256).nullable().optional(),
    customData: jsonObjectGuard.optional(),
    isMfaRequired: z.boolean().optional(),
    isTrustedDeviceAllowed: z.boolean().optional(),
    color: partialColorGuard.optional(),
    branding: brandingGuard.optional(),
    customCss: z.string().nullable().optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    description: z.string().max(256).nullable(),
    customData: jsonObjectGuard,
    isMfaRequired: z.boolean(),
    isTrustedDeviceAllowed: z.boolean(),
    color: partialColorGuard,
    branding: brandingGuard,
    customCss: z.string().nullable(),
    createdAt: z.number(),
});
export const Organizations = Object.freeze({
    table: 'organizations',
    tableSingular: 'organization',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        name: 'name',
        description: 'description',
        customData: 'custom_data',
        isMfaRequired: 'is_mfa_required',
        isTrustedDeviceAllowed: 'is_trusted_device_allowed',
        color: 'color',
        branding: 'branding',
        customCss: 'custom_css',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'name',
        'description',
        'customData',
        'isMfaRequired',
        'isTrustedDeviceAllowed',
        'color',
        'branding',
        'customCss',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
